import { render, staticRenderFns } from "./toast.vue?vue&type=template&id=479f8fc1&scoped=true&"
import script from "./toast.vue?vue&type=script&lang=js&"
export * from "./toast.vue?vue&type=script&lang=js&"
import style0 from "./toast.vue?vue&type=style&index=0&id=479f8fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f8fc1",
  null
  
)

export default component.exports